var React = require('react');

function UiArrowScroll (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ui-arrow-scroll"),React.createElement("path",{"d":"M23,46A23,23,0,1,1,46,23,23,23,0,0,1,23,46Z","style":{"fillRule":"evenodd"},"key":1}),React.createElement("path",{"d":"M29,28l-6,6-6-6","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":2}),React.createElement("path",{"d":"M23,34V12","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":3})]);
}

UiArrowScroll.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 46 46"};

module.exports = UiArrowScroll;

UiArrowScroll.default = UiArrowScroll;
